import { Avatar } from "antd";
import NotificationButton from "features/notifications/elements/NotificationButton";
import { useNotifications } from "features/notifications/useNotifications";
import { useFlag } from "hooks/useFlags";
import { useTexts } from "hooks/useTexts";
import { useUser } from "hooks/useUser";
import React from "react";

import { apiHost } from "../consts";

import "./header.css";

export const FRAME_BASE_URL = "https://bush-vision-88906545.figma.site/";
const LINK_BASE_URL = apiHost;
const FRAME_ID = "frame1";

const navItems = [
  {
    hash: "Home_About",
    textKey: "mission",
    defaultLabel: "Миссия",
  },
  {
    hash: "Home_Cases",
    textKey: "cases",
    defaultLabel: "Кейсы",
  },
  {
    hash: "Home_Events",
    textKey: "events",
    defaultLabel: "Мероприятия",
  },
  {
    hash: "Home_Team",
    textKey: "team",
    defaultLabel: "Команда",
  },
  {
    hash: "Home_Contacts",
    textKey: "contacts",
    defaultLabel: "Контакты",
  },
];

const Header: React.FC = () => {
  const { txt } = useTexts("site_menu");

  const { person, isLoggedIn } = useUser();

  const notificationsEnabled = useFlag("notificationsTest");
  const { count: notificationCount } = useNotifications();

  const avatarUrl =
    person?.avatarUrl || "https://randomuser.me/api/portraits/lego/1.jpg";

  return (
    <header
      className="site-header"
      role="banner"
    >
      <div className="wrap">
        <div className="brand">
          <a href="https://peresoberem.org/">
            <img
              src="https://peresoberem.org/_assets/v11/3a97bd46bb74c7dc216ec14cddada11e37d2c606.svg"
              alt={txt("logo_alt", "пересоберём")}
            />
          </a>
        </div>

        <nav>
          {navItems.map((item) => (
            <a
              key={item.hash}
              href={`${FRAME_BASE_URL}${item.hash}`}
              onClick={(e) => {
                e.preventDefault();
                const frame = document.getElementById(
                  FRAME_ID,
                ) as HTMLIFrameElement | null;

                if (frame) {
                  frame.src = `${FRAME_BASE_URL}#${item.hash}`;
                }
              }}
            >
              {txt(item.textKey, item.defaultLabel)}
            </a>
          ))}
        </nav>

        <div
          className="spacer"
          aria-hidden="true"
        ></div>

        <div className="actions">
          {isLoggedIn ? (
            <>
              <a
                className="profile-link"
                role="link"
                href="/#/profile"
              >
                {txt("profile", "Профиль")}{" "}
                <Avatar
                  size="large"
                  src={avatarUrl}
                />
              </a>
              {notificationsEnabled && (
                <NotificationButton count={notificationCount} />
              )}
              <a
                className="btn btn-accent"
                href={`${LINK_BASE_URL}/solutions/logout/`}
              >
                {txt("logout", "Выйти")}
              </a>
            </>
          ) : (
            <>
              <a
                className="btn btn-ghost"
                href={`${LINK_BASE_URL}/solutions/signup/`}
              >
                {txt("signup", "Регистрация")}
              </a>
              <a
                className="btn btn-accent"
                href={`${LINK_BASE_URL}/solutions/login/`}
              >
                {txt("login", "Войти")}
              </a>
            </>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
